export default __webpack_public_path__ + "static/media/img3.a4fb77ab.jpg";